import { onlyLinkSerializers } from "shared/components/Content";
import { SHOW_MORE, SHOW_LESS, translate } from "shared/utils/translate";
import { useRouter } from "next/router";
import { useRef, useState } from "react";
import BlockContent from "@sanity/block-content-to-react";
import styles from "./Publications.module.css";

const PUBLICATIONS_TRIM_LENGTH = 5;

export const Publications = ({ publications }) => {
  const [isOpen, setIsOpen] = useState(false);
  const { locale } = useRouter();
  const buttonRef = useRef(null);

  function onClick() {
    const scrollY = window.scrollY;
    setIsOpen(!isOpen);

    setTimeout(() => {
      const halfWindow = window.innerHeight / 2;
      const buttonCenter = buttonRef.current.offsetTop - halfWindow;

      window.scrollTo(0, isOpen ? buttonCenter : scrollY);
    }, 0);
  }

  return (
    <div className={styles.publications}>
      {(publications || [])
        .slice(0, isOpen ? publications.length : PUBLICATIONS_TRIM_LENGTH)
        .map((publication) => (
          <BlockContent
            key={JSON.stringify(publication)}
            blocks={publication}
            serializers={onlyLinkSerializers}
          />
        ))}
      {publications.length > PUBLICATIONS_TRIM_LENGTH && (
        <button className={styles.moreButton} onClick={onClick} ref={buttonRef}>
          {isOpen
            ? `- ${translate(SHOW_LESS, locale)}`
            : `+ ${translate(SHOW_MORE, locale)}`}
        </button>
      )}
    </div>
  );
};
